import * as React from 'react';
import { Label as LabelPrimitive } from 'radix-ui';

import { cn } from '@shared/utils/cn';

const Label = ({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) => (
  <LabelPrimitive.Root
    className={cn(
      'flex items-center gap-2 text-sm leading-none font-medium select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
      className
    )}
    data-slot="label"
    {...props}
  />
);

export { Label };
